const POPUP_WIDTH = 290;
const POPUP_HEIGHT = 70;
const POPUP_X_OFFSET = -2;
const POPUP_Y_OFFSET = 20;

function getContent(image, title, subtitle) {
  return `
    <div style="width: ${POPUP_WIDTH}px; height: ${POPUP_HEIGHT}">
      <div class="GoogleMapPopup w-100 pv2 ph2 ba b--light-gray br1 absolute bg-white pointer box-shadow-2">
        <div class="flex items-center">
          <div class="cover bg-center" style="background-image: url(${image}); min-height: 48px; min-width: 48px"></div>
          <div class="truncate flex-auto f2 ml2">
            <p class="fw-medium mb1 truncate">${title}</p>
            <p class="black-50 truncate">${subtitle}</p>
          </div>
        </div>
      </div>
    </div>
  `;
}

export default class GoogleMapPopup extends window.google.maps.OverlayView {
  isVisible = false;

  constructor(opts) {
    super(opts);

    this.opts = opts;
    this.position = opts.position;
    this.setMap(opts.map);

    const pixelOffset = document.createElement('div');
    pixelOffset.innerHTML = getContent(opts.image, opts.title, opts.subtitle);

    this.anchor = document.createElement('div');
    this.anchor.appendChild(pixelOffset);
  }

  bindMouseEvents() {
    const { anchor, opts } = this;
    anchor.addEventListener('mouseenter', opts.onMouseOver);
    anchor.addEventListener('mouseleave', opts.onMouseOut);
    anchor.addEventListener('click', opts.onClick);
  }

  unbindMouseEvents() {
    const { anchor, opts } = this;
    anchor.removeEventListener('mouseenter', opts.onMouseOver);
    anchor.removeEventListener('mouseleave', opts.onMouseOut);
    anchor.removeEventListener('click', opts.onClick);
  }

  onAdd() {
    this.getPanes().floatPane.appendChild(this.anchor);
    this.bindMouseEvents();
  }

  onRemove() {
    if (this.anchor.parentElement) {
      this.anchor.parentElement.removeChild(this.anchor);
    }
    this.unbindMouseEvents();
  }

  show = () => this.draw(true);

  hide = () => this.draw();

  draw = forceDisplay => {
    const divPosition = this.getProjection().fromLatLngToDivPixel(
      this.position
    );
    let display = 'none';

    if (forceDisplay) {
      const left = divPosition.x - (POPUP_WIDTH + POPUP_X_OFFSET) / 2;
      const top = divPosition.y - (POPUP_HEIGHT + POPUP_Y_OFFSET);
      display = 'block';

      this.anchor.style.position = 'absolute';
      this.anchor.style.left = `${left}px`;
      this.anchor.style.top = `${top}px`;
    }

    if (this.anchor.style.display !== display) {
      this.anchor.style.display = display;
    }
  };
}
